import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../../../../assets/img/Icons/White/plane.svg'


const _hoisted_1 = {
  key: 0,
  class: "survey-receive-text"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Submit Answer icon"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "survey-receive-text--answer"
}

import { onMounted, ref } from 'vue'
import { ReceiveText, SurveyDisplayValues } from '@/entities/conversation'

interface Props {
    item: ReceiveText
    surveyDisplayValues?: SurveyDisplayValues
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConversationItemReceiveText',
  props: {
    item: {},
    surveyDisplayValues: {}
  },
  emits: ['callNext'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const answerText = ref('')
const hasAnswer = ref(false)

onMounted(() => {
    if (props.surveyDisplayValues) {
        const savedAnswer = props.surveyDisplayValues[
            props.item?.param
        ] as string
        if (savedAnswer) {
            hasAnswer.value = true
            answerText.value = savedAnswer
        }
    }
})

const submitReplyText = (evt) => {
    evt.preventDefault()
    hasAnswer.value = true
    const newValue = { [props.item.param]: answerText.value }
    emit('callNext', newValue, answerText.value)
}

const onKeyPress = (evt) => {
    if (evt.keyCode === 13 && evt.shiftKey) {
        submitReplyText(evt)
    }
}

return (_ctx: any,_cache: any) => {
  const _directive_autoexpand_height = _resolveDirective("autoexpand-height")!

  return (!hasAnswer.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((answerText).value = $event)),
          autofocus: "",
          "aria-label": "Your answer to the question",
          class: "survey-receive-text--input",
          onKeypress: onKeyPress
        }, null, 544), [
          [_vModelText, answerText.value],
          [_directive_autoexpand_height]
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "survey-receive-text--button",
          "aria-label": "Submit Answer",
          disabled: !answerText.value,
          onClick: submitReplyText
        }, _hoisted_4, 8, _hoisted_2)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString(answerText.value), 1)
      ]))
}
}

})